module.exports = __webpack_public_path__ + "img/home_icon5.af62d303.png";